import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const landingButtonOuterVariants = cva('group p-0.5 rounded-[22px] text-white', {
  variants: {
    variant: {
      primary:
        'bg-[linear-gradient(180deg,#8774E6_0%,#5F46DE_100%)] shadow-[0px_13px_5px_0px_#2810A20F,0px_8px_5px_0px_#2810A230,0px_3px_3px_0px_#2810A252,0px_1px_2px_0px_#2810A25E]',
      secondary:
        'bg-[linear-gradient(180deg,#282828_0%,#060606_100%)] shadow-[0px_12px_5px_0px_#0000000F,0px_7px_4px_0px_#00000030,0px_3px_3px_0px_#00000052,0px_1px_2px_0px_#0000005E]'
    }
  },
  defaultVariants: {
    variant: 'primary'
  }
});

const landingButtonInnerVariants = cva(
  'rounded-[20px] font-semibold px-6 py-3 transition-[box-shadow,transform] duration-300 ease-out group-active:translate-y-[1.5px]',
  {
    variants: {
      variant: {
        primary:
          'bg-[linear-gradient(180deg,#8774E6_0%,#5F46DE_100%)] shadow-[inset_0px_0px_8px_0px_#CBC4EA80,inset_0px_-2px_2px_0px_#28109B,inset_0px_1px_1px_0px_#FFFFFF] group-hover:shadow-[inset_0px_0px_8px_0px_#CBC4EA80,inset_0px_-2px_2px_0px_#28109B,inset_0px_1px_1px_0px_#FFFFFF,inset_1px_0px_1px_0px_#FFFFFF66]',
        secondary:
          'bg-[linear-gradient(0deg,#282828,#282828),linear-gradient(180deg,#282828_0%,#282828_100%)] shadow-[inset_0px_-2px_2px_0px_#000000,inset_0px_1px_1px_0px_#FFFFFFCC] group-hover:shadow-[inset_0px_-2px_2px_0px_#000000,inset_0px_1px_1px_0px_#FFFFFFCC,inset_1px_0px_1px_0px_#FFFFFF66]'
      }
    },
    defaultVariants: {
      variant: 'primary'
    }
  }
);

export interface LandingButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof landingButtonOuterVariants> {
  innerClassName?: string;
}

const LandingButton: React.FC<LandingButtonProps> = ({
  variant = 'primary',
  className,
  innerClassName,
  children,
  type = 'button',
  ...props
}) => {
  return (
    <button type={type} className={cn(landingButtonOuterVariants({ variant }), className)} {...props}>
      <div className={cn(landingButtonInnerVariants({ variant }), innerClassName)}>{children}</div>
    </button>
  );
};

export default LandingButton;
